import { type Rule } from "antd/lib/form"
import type moment from "moment"
import { i18n } from "~Shared/locales/i18n"

const MAX_MONTHS = 24

export const createArchiveSearchRules = ({ isFinwayAdmin }: { isFinwayAdmin: boolean }) => ({
    period: [
        {
            validator: (_rule, value: [moment.Moment, moment.Moment]) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (Math.abs(value[0].diff(value[1], "months")) > MAX_MONTHS) {
                    // only for performance testing
                    if (isFinwayAdmin) {
                        return Promise.resolve()
                    }
                    return Promise.reject(i18n.t("validation:period_too_long", { max: MAX_MONTHS }))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
